'use client'

// React Imports
import { useEffect, useState } from 'react'

// Hook Imports
import { useCookie } from 'react-use'

// Type Imports
import { useColorScheme } from '@mui/material'

import { useSettings } from '@/core/hooks/useSettings'

const useLayoutInit = (colorSchemeFallback: 'light' | 'dark') => {
  // Hooks
  const { settings } = useSettings()
  const { setMode } = useColorScheme()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, updateCookieColorPref] = useCookie('colorPref')
  const [mounted, setMounted] = useState(false)
  const [isDark, setIsDark] = useState(colorSchemeFallback === 'dark')

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted) return

    // Check user's color scheme preference after component mounts
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    setIsDark(mediaQuery.matches)

    const handleChange = (e: MediaQueryListEvent) => {
      setIsDark(e.matches)
    }

    mediaQuery.addEventListener('change', handleChange)

    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [mounted])

  useEffect(() => {
    if (!mounted) return

    const appMode = isDark ? 'dark' : 'light'

    updateCookieColorPref(appMode)

    if (settings.mode === 'system') {
      // We need to change the mode in settings context to apply the mode change to MUI components
      setMode(appMode)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDark, mounted])

  // This hook does not return anything as it is only used to initialize color preference cookie and settings context on first load
}

export default useLayoutInit
